import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import {
  DeleteBar,
  FlexContainer,
  FieldsContainer,
  FieldsSection,
} from "../../../../constants/assets/containers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverNotificationActions from "../../../../store/actions/DriverNotification";
import * as UserActions from "../../../../store/actions/User";
import DateTimePicker from "../../../../components/Common/DateTimePicker";
import Back from "sushiweb/Icons/all/Back";
import Delete from "sushiweb/Icons/all/Delete";
import Breadcrumb from "sushiweb/Breadcrumb";
import { useHistory } from "react-router-dom";
import variables from "../../../../constants/assets/variables";
import LanguageContent from "./languageContent";
import PlusCircle from "sushiweb/Icons/all/PlusCircle";
import { isValNull, isValidURL, getDateTimeAfter } from "../../../../utils";

const NextView = (props) => {
  const {
    setNextView,
    isPopup,
    inputFieldState,
    setInputFieldState,
    newCampaignOptions,
    setDriverServicesPriorityFlag,
    setStatus,
    createCampaign,
    activeCsvHeaders,
  } = props;

  const [languageCount, setLanguageCount] = useState(0);
  const history = useHistory();
  const currentDateTime = getDateTimeAfter(0, inputFieldState.scheduled_time);
  const threeDaysFromNow = getDateTimeAfter(3, inputFieldState.scheduled_time);

  const handleBack = () => {
    setNextView(false);
    setDriverServicesPriorityFlag(true);
  };
  const handleBackClick = () => {
    history.push(`/notification_campaigns`);
  };

  const checkCsvVariablesValidity = (inputText) => {
    const validVariables = activeCsvHeaders.slice(1);
    const variableRegex = /{{(.*?)}}/g;
    const variablesUsed = inputText.match(variableRegex);

    if (variablesUsed) {
      const invalidVariables = variablesUsed
        .map((variable) => variable.slice(2, -2))
        .filter((variable) => !validVariables.includes(variable));

      if (invalidVariables.length > 0) {
        return invalidVariables;
      }
    }

    return null;
  };

  const validateDetails = () => {
    if (isPopup && isValNull(inputFieldState.expiry_time)) {
      var expiryTime = getDateTimeAfter(1, inputFieldState.scheduled_time);
      setInputFieldState((prevState) => {
        return { ...prevState, expiry_time: expiryTime };
      });
    }

    const detailsArray = inputFieldState.notification_details;
    for (
      let languageIndex = 0;
      languageIndex < detailsArray.length;
      languageIndex++
    ) {
      const detailsHash = detailsArray[languageIndex];
      if (isValNull(detailsHash.language)) {
        return `Please select ${
          languageIndex == 0
            ? "default language"
            : `additional language ${languageIndex}`
        }`;
      }
      if (isValNull(detailsHash.title)) {
        return `Please enter notification title on ${
          languageIndex == 0
            ? "default language"
            : `additional language ${languageIndex}`
        } section`;
      }
      if (detailsHash.title.length > 50) {
        return `Char limit exceeded of notification title on ${
          languageIndex == 0
            ? "default language"
            : `additional language ${languageIndex}`
        } section`;
      }
      if (!isPopup && isValNull(detailsHash.content)) {
        return `Please enter message content on ${
          languageIndex == 0
            ? "default language"
            : `additional language ${languageIndex}`
        } section`;
      }
      if (inputFieldState.driver_selection_type == "GEOGRAPHY") {
        const variableRegex = /{{(.*?)}}/g;
        const variablesUsedTitle = detailsHash.title.match(variableRegex);
        const variablesUsedMessage = detailsHash.content.match(variableRegex);
        if (variablesUsedTitle || variablesUsedMessage) {
          return `Invalid content, variables in double curly braces found on ${
            languageIndex == 0
              ? "default language"
              : `additional language ${languageIndex}`
          } section.`;
        }
      }
      if (inputFieldState.driver_selection_type == "CSV") {
        const invalidVariablesTitle = checkCsvVariablesValidity(
          detailsHash.title
        );
        if (invalidVariablesTitle && invalidVariablesTitle.length > 0) {
          const invalidVariablesString = invalidVariablesTitle.join(", ");
          return `Invalid variable(s) found in title (${invalidVariablesString}) on ${
            languageIndex == 0
              ? "default language"
              : `additional language ${languageIndex}`
          } section.`;
        }

        const invalidVariablesMessage = checkCsvVariablesValidity(
          detailsHash.content
        );
        if (invalidVariablesMessage && invalidVariablesMessage.length > 0) {
          const invalidVariablesString = invalidVariablesMessage.join(", ");
          return `Invalid variable(s) found in message content (${invalidVariablesString}) on ${
            languageIndex == 0
              ? "default language"
              : `additional language ${languageIndex}`
          } section.`;
        }
      }
      if (detailsHash.content.length > 1500) {
        return `Char limit exceeded of message content on ${
          languageIndex == 0
            ? "default language"
            : `additional language ${languageIndex}`
        } section`;
      }
      if (
        detailsHash.media.type == "AUDIO" ||
        detailsHash.media.type == "VIDEO"
      ) {
        if (
          detailsHash.media.type == "VIDEO" &&
          detailsHash.media.orientation == ""
        ) {
          return `Please select video orientation on ${
            languageIndex == 0
              ? "default language"
              : `additional language ${languageIndex}`
          } section`;
        }
        if (
          isValNull(detailsHash.media.url) ||
          (detailsHash.media.type == "AUDIO" &&
            detailsHash.media.url.slice(-4) != ".mp3" &&
            detailsHash.media.url.slice(-5) != ".m3u8") ||
          (detailsHash.media.type == "VIDEO" &&
            detailsHash.media.url.slice(-5) != ".m3u8") ||
          !isValidURL(detailsHash.media.url)
        ) {
          return `Please enter valid media url on ${
            languageIndex == 0
              ? "default language"
              : `additional language ${languageIndex}`
          } section`;
        }
      }
      if (detailsHash.media.type == "IMAGE" && isValNull(detailsHash.image)) {
        return `Please upload an image on ${
          languageIndex == 0
            ? "default language"
            : `additional language ${languageIndex}`
        } section`;
      }
    }

    return "validated";
  };

  const handleSendNotification = () => {
    let validatedState = validateDetails();
    if (validatedState === "validated") {
      createCampaign(inputFieldState).then((res) => {
        if (res) {
          setTimeout(() => {
            history.push(`/notification_campaigns`);
            window.location.reload();
          }, 1000);
        }
      });
    } else {
      setStatus({ type: "error", message: validatedState });
    }
  };
  const handleChange = (key, val) => {
    setInputFieldState((prevState) => {
      return { ...prevState, [key]: val };
    });
  };

  const handleLanguageDelete = (index) => {
    const values = { ...inputFieldState };
    values["notification_details"].splice(index, 1);
    setInputFieldState(values);
  };

  const handleAddLanguage = () => {
    setLanguageCount(languageCount + 1);

    // Adding new language notification details to our inputState
    const updatedInputFieldState = {
      ...inputFieldState,
      notification_details: [
        ...inputFieldState.notification_details,
        {
          language: "",
          title: "",
          content: "",
          media: {
            type: "TEXT_ONLY",
            url: "",
            orientation: "PORTRAIT",
          },
          actions: [],
          image: "",
          image_name: "",
          default_language: false,
        },
      ],
    };
    setInputFieldState(updatedInputFieldState);
  };

  return (
    <section>
      <FlexContainer justify="flex-start">
        &emsp;
        <Back
          onClick={handleBackClick}
          className="mr-10 backBtn"
          color={variables.grey400}
        />
        <Breadcrumb className="sushi-breadcrumbs">
          <Breadcrumb.Link onClick={handleBackClick}>
            Notifications
          </Breadcrumb.Link>
          <Breadcrumb.Link>Create campaign</Breadcrumb.Link>
        </Breadcrumb>
      </FlexContainer>

      <FieldsContainer border noPadding className="mt-10">
        <FieldsHolder>
          <FlexContainer>
            <FieldsSection marginBottom="1.75rem">
              <p className="section-heading">
                {isPopup ? "POP-UP" : "TRAY"} NOTIFICATION DETAILS
              </p>
            </FieldsSection>
            <Button
              data-testid="backButton"
              className="sushi-btn mr-10 width-2"
              onClick={handleBack}
            >
              &lt;&lt; Back
            </Button>
          </FlexContainer>
          <ExpirySection>
            {isPopup ? (
              <React.Fragment>
                <FlexContainer className="mt-20">
                  <p className="expiryText">Expiry</p>
                  <div className="datepicker">
                    <DateTimePicker
                      value={inputFieldState.expiry_time}
                      handleChange={(e) =>
                        handleChange("expiry_time", e.target.value)
                      }
                      disableBefore={currentDateTime}
                      disableAfter={threeDaysFromNow}
                      placeholder=""
                      id="expiryTime"
                    />
                  </div>
                </FlexContainer>
                <p className="mt-10 mb-20 ml-12 opacity-5 text-grey">
                  Expired notifications are not visible to drivers. Please
                  choose valid date-time for notification to expire.
                  <br />
                  Default expiry time is 1 day.
                </p>
              </React.Fragment>
            ) : (
              ""
            )}
          </ExpirySection>
          <LanguageContent
            isDefault={true}
            key={0}
            languageIndex={0}
            inputFieldState={inputFieldState}
            setInputFieldState={setInputFieldState}
            newCampaignOptions={newCampaignOptions}
            isPopup={isPopup}
          />
        </FieldsHolder>
        {inputFieldState.notification_details.map(
          (detailsJson, languageIndex) => {
            return (
              <React.Fragment>
                {languageIndex > 0 ? (
                  <FieldsHolder>
                    <LanguageContent
                      isDefault={false}
                      key={languageCount}
                      languageIndex={languageIndex}
                      inputFieldState={inputFieldState}
                      setInputFieldState={setInputFieldState}
                      newCampaignOptions={newCampaignOptions}
                      isPopup={isPopup}
                    />
                    <FlexContainer className="mt-10">
                      <DeleteBar
                        onClick={() => handleLanguageDelete(languageIndex)}
                      >
                        <Delete
                          className="mr-10"
                          size={20}
                          color={variables.red500}
                        />
                        <span>Delete Language</span>
                      </DeleteBar>
                    </FlexContainer>
                  </FieldsHolder>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          }
        )}
        {inputFieldState.notification_for != "Onboarding Applicants" && (
          <AddLanguageContainer
            onClick={() => {
              handleAddLanguage();
            }}
            justify={"flex-end"}
          >
            <div className="flex delete-icon">
              <PlusCircle color={variables.red500} size={20} />
              <span>Add another language</span>
            </div>
          </AddLanguageContainer>
        )}
      </FieldsContainer>
      <FlexContainer justify={"flex-end"}>
        <SendButton>
          <Button
            data-testid="sendButton"
            className="sushi-btn w-25"
            onClick={handleSendNotification}
          >
            Send Notification
          </Button>
        </SendButton>
      </FlexContainer>
    </section>
  );
};

const AddLanguageContainer = styled(FlexContainer)`
  span {
    color: ${variables.red500};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;

const SendButton = styled.div`
  flex: 0 1 65%;
  margin-bottom: 30px;
`;

const FieldsHolder = styled.div`
  padding: 1.875rem;
`;

const ExpirySection = styled.div`
  border-bottom: 1px solid ${variables.grey200};
  margin-bottom: 15px;
  padding-bottom: 15px;
  .expiryText {
    flex: 0 1 10%;
    height: 3rem;
    padding: 15px;
    margin-bottom: 15px;
  }
  .datepicker {
    flex: 0 1 90%;
    height: 50px;
    margin-bottom: 15px;
  }
  input {
    width: 250px;
  }
`;

function mapStateToProps(state) {
  const { User } = state;
  return {
    status: User.status,
    activeCsvHeaders: User.activeCsvHeaders,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    createCampaign: bindActionCreators(
      DriverNotificationActions.createCampaign,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NextView);
